import React from "react";
import { REAL_ESTATE_EXTRA_FLOW_CONFIGS } from "./real-estateProcessFlowExtra";

const FLOW_CONFIGS = REAL_ESTATE_EXTRA_FLOW_CONFIGS;
const STEP_COUNT = 6;

const styles = `
  .p2-diag { background: #fff; border-radius: 8px; overflow: hidden; border: 1px solid #dbe7f7; font-family: Roboto, sans-serif; }
  .p2-diag-head { background: #1d3f7d; padding: 14px 16px 12px; text-align: center; }
  .p2-diag-head h4 { font-family: Exo, sans-serif; font-size: 15px; font-weight: 700; color: #fff; margin: 0 0 4px; }
  .p2-diag-head p { margin: 0; font-size: 11px; color: rgba(255,255,255,0.85); }
  .p2-diag-hitl { background: #f4f7fb; padding: 10px 12px 6px; border-bottom: 1px solid #e2eaf4; }
  .p2-diag-hitl-label { font-family: Exo, sans-serif; font-size: 9px; font-weight: 700; color: #c45d1e; text-transform: uppercase; text-align: center; margin: 0 0 8px; }
  .p2-diag-hitl-row, .p2-diag-body { display: grid; grid-template-columns: 108px repeat(${STEP_COUNT}, minmax(0,1fr)) 108px; gap: 4px; min-width: 0; }
  .p2-diag-hitl-pill { grid-column: span 2; background: linear-gradient(180deg,#f5a84c 0%,#e8913a 100%); color: #fff; font-size: 9px; font-weight: 600; text-align: center; padding: 6px 4px; border-radius: 6px; }
  .p2-diag-io { background: #f0f6fc; border: 1px solid #d4e3f5; border-radius: 6px; padding: 8px; align-self: stretch; }
  .p2-diag-io h5 { font-size: 9px; font-weight: 700; color: #1d3f7d; text-transform: uppercase; text-align: center; margin: 0 0 6px; }
  .p2-diag-io ul { margin: 0; padding-left: 14px; font-size: 8px; color: #3a4d62; line-height: 1.45; }
  .p2-diag-step { background: linear-gradient(180deg,#fff 0%,#f7fbff 100%); border: 1px solid #d4e3f5; border-radius: 6px; padding: 6px 5px; min-height: 118px; display: flex; flex-direction: column; }
  .p2-diag-step-head { display: flex; align-items: center; gap: 4px; margin-bottom: 4px; }
  .p2-diag-step-num { width: 14px; height: 14px; border-radius: 50%; background: #1d3f7d; color: #fff; font-size: 8px; font-weight: 700; display: flex; align-items: center; justify-content: center; }
  .p2-diag-step-title { font-size: 8px; font-weight: 700; color: #1d3f7d; }
  .p2-diag-step-icon { text-align: center; color: #27baa7; font-size: 16px; margin: 2px 0 4px; }
  .p2-diag-step-tasks { margin: 0 0 auto; padding-left: 10px; font-size: 7px; color: #4a5d72; line-height: 1.35; flex: 1; }
  .p2-diag-step-agent { margin-top: 4px; padding-top: 4px; border-top: 1px dashed #d4e3f5; text-align: center; }
  .p2-diag-step-agent strong { display: block; font-size: 7px; color: #1d3f7d; }
  .p2-diag-step-agent span { font-size: 6px; color: #27baa7; text-transform: uppercase; }
  .p2-diag-systems { background: #1d3f7d; padding: 8px 12px; display: flex; flex-wrap: wrap; gap: 6px; justify-content: center; align-items: center; }
  .p2-diag-systems span { font-size: 8px; font-weight: 600; color: #1d3f7d; background: #fff; border-radius: 4px; padding: 3px 8px; }
  .p2-diag-systems p { margin: 0; font-size: 8px; color: rgba(255,255,255,0.8); }
  .p2-diag-scroll { overflow-x: auto; }
`;

export default function RealEstateProcessFlow({ useCaseId }) {
  const config = FLOW_CONFIGS[useCaseId];
  if (!config) return null;
  return (
    <div className="p2-diag" role="img" aria-label={config.title}>
      <style>{styles}</style>
      <header className="p2-diag-head"><h4>{config.title}</h4><p>{config.subtitle}</p></header>
      <div className="p2-diag-scroll">
        <div className="p2-diag-hitl">
          <p className="p2-diag-hitl-label">Human-in-the-loop checkpoints</p>
          <div className="p2-diag-hitl-row">
            {config.checkpoints.map((cp) => (
              <div key={cp.label} className="p2-diag-hitl-pill" style={{ gridColumn: `${cp.startCol} / span 2` }}>{cp.label}</div>
            ))}
          </div>
        </div>
        <div className="p2-diag-body">
          <aside className="p2-diag-io" aria-label="Inputs"><h5>Inputs</h5><ul>{config.inputs.map((i) => <li key={i}>{i}</li>)}</ul></aside>
          {config.steps.map((step) => {
            const Icon = step.icon;
            return (
              <div key={step.id} className="p2-diag-step">
                <div className="p2-diag-step-head"><span className="p2-diag-step-num">{step.id}</span><span className="p2-diag-step-title">{step.title}</span></div>
                <div className="p2-diag-step-icon"><Icon /></div>
                <ul className="p2-diag-step-tasks">{step.tasks.map((t) => <li key={t}>{t}</li>)}</ul>
                <footer className="p2-diag-step-agent"><strong>{step.agent}</strong><span>{step.agentRole}</span></footer>
              </div>
            );
          })}
          <aside className="p2-diag-io" aria-label="Outputs"><h5>Outputs</h5><ul>{config.outputs.map((i) => <li key={i}>{i}</li>)}</ul></aside>
        </div>
      </div>
      <footer className="p2-diag-systems"><p>Systems:</p>{config.systems.map((s) => <span key={s}>{s}</span>)}</footer>
    </div>
  );
}

